module.exports = __webpack_public_path__ + "9b50f08e949a88cda39853942240f735.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logout.svg
// module id = 350
// module chunks = 0